import CustomReactTooltip from "./customReactTooltip";

export default CustomReactTooltip;